var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.multipleSelect')}},[_c('el-switch',{model:{value:(_vm.optionModel.multipleSelect),callback:function ($$v) {_vm.$set(_vm.optionModel, "multipleSelect", $$v)},expression:"optionModel.multipleSelect"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }